import React, { useEffect, useCallback } from 'react'
import AutomatedCallSetting from 'app/main/settings/manageChannels/automatedCallSetting/AutomatedCallSetting'
import { useManageChannelsContent } from './useManageChannelsContent'
import * as R from 'ramda'
import debounce from 'lodash.debounce'

const ManageChannelsContent = () => {
  const {
    state: { automatedCallSetting, isLoadingAutomatedCallSetting },
    fetchAutomatedCallSetting,
    setLoading,
  } = useManageChannelsContent()

  const debounceFetch = useCallback(
    debounce(() => {
      fetchAutomatedCallSetting(false)
    }, 500),
    [],
  )

  const onSuccess = () => {
    setLoading()
    debounceFetch()
  }

  useEffect(fetchAutomatedCallSetting, [])

  if (R.isEmpty(automatedCallSetting)) {
    return null
  }

  return (
    <>
      <AutomatedCallSetting
        setting={automatedCallSetting}
        onSuccess={onSuccess}
        isloading={isLoadingAutomatedCallSetting}
      />
    </>
  )
}

export default ManageChannelsContent
